import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, Subscriber} from 'rxjs';
import {Project} from '../_models/project';
import {AbilityService} from '../_services/ability.service';
import {Ability} from '@casl/ability';

@Injectable({
  providedIn: 'root'
})
export class ProjectGuard implements CanActivate {

  constructor(public abilitySvc: AbilityService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return new Observable<boolean>((observer: Subscriber<boolean>) => {
      this.abilitySvc.ability.subscribe((ability: Ability) => {
        observer.next(ability.can('read', 'Project'));
      });
    });
  }

}
